export const firebaseConfig = {
  apiKey: "AIzaSyCn29qvxSaklNAUejJBuQir7wN3Hjb5lzE",
  authDomain: "campus-tutiendaonline.firebaseapp.com",
  databaseURL: "https://campus-tutiendaonline.firebaseio.com",
  projectId: "campus-tutiendaonline",
  storageBucket: "campus-tutiendaonline.appspot.com",
  messagingSenderId: "777975458902",
  appId: "1:777975458902:web:d3ed5349f31c55c463dff7",
  measurementId: "G-6W8PPEPMZ8"
}
